import React from 'react';

import ChevronIcon from 'Component/ChevronIcon';
import { LEFT } from 'Component/ChevronIcon/ChevronIcon.config';
import Link from 'Component/Link';
import MyAccountCustomerServicePush from 'Component/MyAccountCustomerServicePush';
import MyAccountOrderFavoriteButton from 'Component/MyAccountOrderFavoriteButton';
import MyAccountOrderTimeline from 'Component/MyAccountOrderTimeline';
import { ACCOUNT_ORDER_HISTORY } from 'Route/MyAccount/MyAccount.config';
import {
    MyAccountOrder as SourceMyAccountOrder
} from 'SourceComponent/MyAccountOrder/MyAccountOrder.component';
import { convertStringToDate } from 'Util/Manipulations/Date';
import { appendWithStoreCode } from 'Util/Url';

import './MyAccountOrder.override.style';

/** @namespace PeggysagePwa/Component/MyAccountOrder/Component */
export class MyAccountOrderComponent extends SourceMyAccountOrder {
    renderLinkBackToHistory() {
        const { isMobile } = this.props;

        if (isMobile) {
            return null;
        }

        return (
            <Link
              block="MyAccountOrder"
              elem="BackLink"
              to={ appendWithStoreCode(ACCOUNT_ORDER_HISTORY) }
            >
                <ChevronIcon direction={ LEFT } />
                { __('Retour à l\'historique des commandes') }
            </Link>
        );
    }

    renderFavoriteLink() {
        const { order } = this.props;

        return (
            <MyAccountOrderFavoriteButton
              order={ order }
              mix={ { block: 'MyAccountOrder', elem: 'FavoriteButton' } }
            />
        );
    }

    renderTimeline() {
        const { order } = this.props;

        return <MyAccountOrderTimeline order={ order } />;
    }

    renderCustomerService() {
        const { order } = this.props;

        return (
            <MyAccountCustomerServicePush order={ order } />
        );
    }

    /**
     * Override
     * @returns {JSX.Element|null}
     */
    renderReorderButton() {
        const { is_allowed_reorder, handleReorder, order: { can_reorder } } = this.props;

        if (!is_allowed_reorder || !can_reorder) {
            return null;
        }

        return (
            <button
              block="Button"
              mix={ { block: 'MyAccountOrder', elem: 'Reorder' } }
              onClick={ handleReorder }
            >
                { __('Reorder') }
            </button>
        );
    }

    renderDownloadInvoiceButton() {
        const { order: { pdfInvoice } } = this.props;

        if (!pdfInvoice) {
            return null;
        }

        /* eslint-disable @scandipwa/scandipwa-guidelines/jsx-no-conditional */
        return pdfInvoice.map((value, _key) => (
            <Link
              block="MyAccountOrder"
              elem="InvoiceButton"
              mix={ { block: 'Button', mods: { isHollow: true } } }
              className="pdf-button"
              to={ value }
              download
              title={ value.indexOf('/file/A') !== -1 ? __('Download my creditmemo') : __('Download my invoice') }
            >
                { value.indexOf('/file/A') !== -1 ? __('Download my creditmemo') : __('Download my invoice') }
            </Link>
        ));
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    renderActions() {
        return (
            <div block="MyAccountOrder" elem="Actions">
                { this.renderReorderButton() }
                { this.renderDownloadInvoiceButton() }
            </div>
        );
    }

    /**
     * Override
     * @returns {JSX.Element}
     */
    renderBaseInfo() {
        const { order: { increment_id, order_date } } = this.props;

        return (
            <div block="MyAccountOrder" elem="CreationDate">
                { __('Order # %s from %s', increment_id, convertStringToDate(order_date)) }
            </div>
        );
    }

    renderContent() {
        const { order: { items } } = this.props;

        if (!items) {
            return null;
        }

        return (
            <>
                { this.renderLinkBackToHistory() }
                { this.renderFavoriteLink() }
                <div block="MyAccountOrder" elem="Header">
                    { this.renderBaseInfo() }
                    { this.renderActions() }
                    { this.renderTimeline() }
                    { this.renderCustomerService() }
                    { this.renderOrderComments() }
                </div>
                <div block="MyAccountOrder" elem="Content">
                    { this.renderActiveTab() }
                    { this.renderOrderInformation() }
                </div>
            </>
        );
    }
}

export default MyAccountOrderComponent;
